/**
 * LeafyHabit cart drawer add-ons.
 * Cards are rendered in Liquid (snippets/cart-upsell.liquid); this file only
 * wires the Add buttons and size selects. A MutationObserver catches every
 * Section Rendering API re-render of the drawer.
 */
(function () {
  if (window.__leafyCartUpsell) return;
  window.__leafyCartUpsell = true;
  var SECTION_ID = 'cart-drawer-section';

  async function syncCartCount() {
    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var n = String(cart.item_count);
      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = n; });
    } catch (e) {}
  }

  async function refreshDrawer() {
    try {
      var res = await fetch('/?sections=' + SECTION_ID).then(function (r) { return r.json(); });
      var html = res[SECTION_ID];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.cart-drawer__inner');
      var current = document.querySelector('.cart-drawer__inner');
      if (fresh && current) current.replaceWith(fresh);
      await syncCartCount();
    } catch (e) {}
  }

  async function addVariant(id, button) {
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding';
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!r.ok) throw new Error('add failed');
      await refreshDrawer();
    } catch (e) {
      button.disabled = false;
      button.textContent = original;
    }
  }

  function wire(root) {
    root.querySelectorAll('.cu-card').forEach(function (card) {
      var btn = card.querySelector('[data-cu-add]');
      var sel = card.querySelector('[data-cu-variant]');
      if (!btn) return;
      if (sel) sel.addEventListener('change', function () { btn.setAttribute('data-cu-add', sel.value); });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addVariant(btn.getAttribute('data-cu-add'), btn);
      });
    });
  }

  function scan() {
    var nodes = document.querySelectorAll('[data-cart-upsell]:not([data-cu-ready])');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-cu-ready', '1');
      wire(nodes[i]);
    }
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
